import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/login-approval/empty-history.svg'


const _hoisted_1 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_2 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_3 = { class: "items-center" }
const _hoisted_4 = { class: "flex gap-x-2" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-6 flex-1 justify-center"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "mx-auto",
  style: {"width":"176px","height":"auto"},
  src: _imports_0,
  alt: "default"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col gap-y-2 items-center" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-center text-gray-lp-300 text-sm font-semibold" }, " Belum Ada Riwayat "),
  /*#__PURE__*/_createVNode("p", {
    class: "text-center text-gray-lp-600 text-sm",
    style: {"max-width":"500px"}
  }, " Data riwayat Permintaan login dan informasi perangkat tim Anda akan otomatis muncul disini setelah ada aktivitas pertama. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_ApprovalResultNotFound = _resolveComponent("ApprovalResultNotFound")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "py-2 px-3 flex-grow flex flex-col min-h-0",
      rounded: "lg",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Search, {
                id: "search-login-approval",
                onInput: _ctx.onSearch,
                onClear: _ctx.clearSearch,
                value: _ctx.search,
                class: "w-300px",
                placeholder: "Cari nama user / device / kode"
              }, null, 8, ["onInput", "onClear", "value"]),
              _createVNode(_component_time_range_picker, {
                id: "time-range-picker-login-approval",
                startDate: _ctx.startDate,
                endDate: _ctx.endDate,
                maxDate: _ctx.getFormattedDate(),
                onSelect: _ctx.setDateRange,
                default: "7 hari terakhir",
                showOptions: "custom, hari ini, 7 hari terakhir, 14 hari terakhir"
              }, null, 8, ["startDate", "endDate", "maxDate", "onSelect"])
            ])
          ]),
          (
            _ctx.loginApprovalHistoryList.length === 0 &&
              _ctx.search === '' &&
              !_ctx.isLoading &&
              !_ctx.errorCause
          )
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7
              ]))
            : (
            _ctx.loginApprovalHistoryList.length === 0 &&
              _ctx.search !== '' &&
              !_ctx.isLoading &&
              !_ctx.errorCause
          )
              ? (_openBlock(), _createBlock(_component_ApprovalResultNotFound, { key: 1 }))
              : (_openBlock(), _createBlock(_component_TableV2, {
                  key: 2,
                  pagination: _ctx.pagination,
                  "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                  loading: _ctx.isLoading,
                  columns: _ctx.columns,
                  class: "my-2 rounded-xl",
                  errorCause: _ctx.errorCause,
                  isShowTryAgainBtn: "",
                  onTryAgain: _ctx.fetchLoginApproval,
                  data: _ctx.loginApprovalHistoryList,
                  borderTop: false,
                  totalColumnFreeze: 0,
                  pinnedSubstractHeight: "280px",
                  paginationStyle: "v3",
                  bgHeader: "bg-white",
                  isBorderOnHeadBgWhite: "",
                  isNoPaddingBottom: "",
                  customClassPagination: "w-full h-full flex items-end px-3",
                  isSpaceTop: false,
                  headerTextColor: "text-black-lp-200",
                  onRequest: _ctx.fetchLoginApproval
                }, null, 8, ["pagination", "loading", "columns", "errorCause", "onTryAgain", "data", "onRequest"]))
        ])
      ]),
      _: 1
    })
  ]))
}